// Preferred display name order for clients across the app.
export const getClientDisplayName = (clientData) =>
  clientData?.displayName ||
  clientData?.otherName ||
  clientData?.name ||
  clientData?.username ||
  clientData?.email ||
  "";
